const FileIcon = ({ width = 55, height = 55, fill = "var(--primary)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M16 4C12.6863 4 10 6.68629 10 10V54C10 57.3137 12.6863 60 16 60H48C51.3137 60 54 57.3137 54 54V22L38 4H16Z"
        fill={fill}
      />

      <path d="M38 4V18C38 20.2091 39.7909 22 42 22H54" fill="#C4A1FF" />

      <path d="M38 4L54 22H42C39.7909 22 38 20.2091 38 18V4Z" fill="#E9D8FD" />

      <path
        d="M16 4H38L54 22V24H10V10C10 6.68629 12.6863 4 16 4Z"
        fill="white"
        opacity="0.08"
      />

      <rect
        x="18"
        y="30"
        width="28"
        height="3.5"
        rx="1.75"
        fill="white"
        opacity="0.85"
      />

      <rect
        x="18"
        y="38"
        width="22"
        height="3.5"
        rx="1.75"
        fill="white"
        opacity="0.6"
      />

      <rect
        x="18"
        y="46"
        width="16"
        height="3.5"
        rx="1.75"
        fill="white"
        opacity="0.4"
      />

      {/* Bottom shadow */}
      <path
        d="M10 50C10 55 13 60 18 60H46C51 60 54 55 54 50V54C54 57.3137 51.3137 60 48 60H16C12.6863 60 10 57.3137 10 54V50Z"
        fill="#4C1D95"
        opacity="0.18"
      />
    </svg>
  );
};

export default FileIcon;
